// extracted by mini-css-extract-plugin
export default {"container":"sO-z","dimension":"tO-z","dimensionLabels":"uO-z"};